import { useAppDispatch, useAppSelector } from "app.hook";
import * as React from "react";
import { shallowEqual } from "react-redux";
import { formatMoney, redirectFileLocalUrl } from "shared/plugins/string-helper";
import { selectBranchOrderPickupSetting } from "states/branch-order-pickup-setting/order-pickup-setting.slice";
import { IModifierGroupModel, IProductModel } from "states/menu/menu.models";
import { IProductItemSelectedModel } from "states/shopping-cart/shopping-cart.models";
import { setModalAddItem, setProductSelected } from "states/shopping-cart/shopping-cart.slice";
import AddToCart from "../../../../themes/icons/add-to-cart.svg";
export interface IMenuBoxItemProps {
  product: IProductModel;
  modifierGroups: IModifierGroupModel[];
}

export function MenuBoxItem({ product, modifierGroups }: IMenuBoxItemProps) {
  const dispatch = useAppDispatch();
  const _handleOpenModal = () => {
    dispatch(setProductSelected({ product, modifierGroups } as IProductItemSelectedModel));
    dispatch(setModalAddItem(true));
  }
  const orderSetting = useAppSelector(selectBranchOrderPickupSetting, shallowEqual);
  return (
    <div onClick={!product.notAdded && orderSetting?.active ? _handleOpenModal : undefined} className="relative item-menu mb-2 bg-white rounded-md shadow-lg  flex flex-row w-full ">
      <div className="img-box img--container-center transition-primary relative">
        <img className="w-full" src={redirectFileLocalUrl(product.images?.length > 0 ? product.images[0] : "/images/food-place-holder.jpg")} alt="" />
        {!product.notAdded && orderSetting?.active && (
          <button className="btn--default add-to-cart transition-primary">
            <img onClick={_handleOpenModal} src={AddToCart} alt="" />
          </button>
        )}
      </div>
      <div className="detail-box flex-auto p-2">
        <div className="top-detail">
          {!product?.notAdded && orderSetting?.active ? (
            <div onClick={_handleOpenModal} className="name font-semibold text-sm">{product?.name}</div>
          ) : (
            <div className="name font-semibold text-sm">{product?.name}</div>
          )}
        </div>
        <div className="bot-detail pt-3">
          {product?.description && (
            <div className="des">
              <div
                dangerouslySetInnerHTML={{
                  __html: product?.description,
                }}
                className="des-inner"
              >
              </div>
            </div>
          )}

          <div className={`btn--container w-full`}>
            <div className="price flex-auto text-red text-lg font-medium mb-4">{formatMoney(product?.sellingPrice, 2, ".", ",", "$")}</div>
            {!product?.notAdded && orderSetting?.active && (
              <button onClick={() => _handleOpenModal()} className={`p-1 rounded-md btn--primary `}>
                <img src={AddToCart} alt="" className="w-full text-center" />
              </button>
            )}
          </div>
        </div>
      </div>
      {product.label && (
        <div className="ribbon"><span>{product.label}</span></div>
      )}
    </div>
  );
}
